// extracted by mini-css-extract-plugin
module.exports = {"address-container":"AddressBar_address-container__1Yc6w","address-bar":"AddressBar_address-bar__2vjnQ","social-icons":"AddressBar_social-icons__37M6b"};